export default __webpack_public_path__ + "static/icon-b637d195e677c49db944f32386f5f9d9.png";